import React from 'react';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";
import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";

import {red700} from "assets/jss/main";

function LimitedProductBadge({code = null}) {
    if (!code) {
        return null;
    }

    return (
        <div style={{marginBottom: '24px'}}>
            <Badge
                color={'error'}
                isBold={false}
                border
                size={'xl'}
                labelColor={red700}
                labelSize={14}
                fullWidth={true}
                centerContent
            >
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    textTransform: 'none'
                }}>
                    <FormattedMessage id='product.show.product.form.limitedDistribution.message' values={{code}} />
                    <InfoTooltipIcon titleId={'product.show.product.form.limitedDistribution.tooltip'} color={red700} />
                </div>
            </Badge>
        </div>

    );
}

export default LimitedProductBadge;
